import AvalancheIcon from "./assets/networks/Avalanche_AVAX_RedWhite.svg";
import HardhatIcon from "./assets/networks/hardhat.svg";
import EthereumIcon from "./assets/networks/eth-diamond-purple.svg";

const networkConfig = {
  Ethereum: {
    name: "Ethereum Mainnet",
    chainId: "1",
    rpcUrl: "https://eth.llamarpc.com",
    symbol: "ETH",
    blockExplorerUrl: ["https://etherscan.io/"],
    usdcTokenContract: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    agroforestryProjectFactoryContract:
      process.env.AGROFORESTRY_PROJECT_FACTORY_CONTRACT,
    icon: EthereumIcon,
  },
  Avalanche: {
    name: "Avalanche C-Chain",
    chainId: "43114",
    rpcUrl: "https://api.avax.network/ext/bc/C/rpc",
    symbol: "AVAX",
    blockExplorerUrl: ["https://snowtrace.io/"],
    usdcTokenContract: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
    agroforestryProjectFactoryContract:
      process.env.AGROFORESTRY_PROJECT_FACTORY_CONTRACT,
    icon: AvalancheIcon,
  },
  Sepolia: {
    name: "Ethereum Sepolia",
    chainId: "11155111",
    rpcUrl: "https://sepolia.infura.io/v3/b00745ab213841c082168b25f3218c11",
    symbol: "SepoliaETH",
    blockExplorerUrl: ["https://sepolia.etherscan.io/"],
    usdcTokenContract: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
    agroforestryProjectFactoryContract:
      "0xb7a76327b66a98C45300260c2e1fBA22138c073e",
    icon: EthereumIcon,
  },
  Fuji: {
    name: "Avalanche Fuji Testnet",
    chainId: "43113",
    rpcUrl: process.env.RPC_URL || "https://api.avax-test.network/ext/bc/C/rpc",
    symbol: "AVAX",
    blockExplorerUrl: ["https://testnet.snowtrace.io/"],
    bctTokenContract: process.env.CARBON_V2_BCT,
    carbonV2StakingDistributorContract:
      process.env.CARBON_V2_RECEIPT_STAKING_DISTRIBUTOR,
    carbonV2YieldRouterContract: process.env.CARBON_V2_YIELD_ROUTER,
    kycWhitelistContract: process.env.KYC_WHITELIST_CONTRACT,
    credit1155Contract: process.env.CREDIT_1155_CONTRACT,
    usdcTokenContract: process.env.USDC_TOKEN_CONTRACT,
    agroforestryProjectFactoryContract:
      process.env.AGROFORESTRY_PROJECT_FACTORY_CONTRACT,
    icon: AvalancheIcon,
  },
  Holesky: {
    name: "Holesky",
    chainId: "17000",
    rpcUrl: "https://holesky.drpc.org",
    symbol: "ETH",
    blockExplorerUrl: ["https://holesky.beaconcha.in"],
    usdcTokenContract: "0x8464135c8F25Da09e49BC8782676a84730C318bC",
    agroforestryProjectFactoryContract:
      "0x28AD730c97cb882b034349a957A2ab21695F3D11",
    icon: EthereumIcon,
  },
  Hardhat: {
    name: "BrazilCarbon QA",
    chainId: String(process.env.VUE_APP_CHAIN_ID || process.env.CHAIN_ID || "31338"),
    rpcUrl: process.env.RPC_URL || "http://127.0.0.1:8545",
    symbol: "ETH",
    bctTokenContract: process.env.CARBON_V2_BCT,
    carbonV2StakingDistributorContract:
      process.env.CARBON_V2_RECEIPT_STAKING_DISTRIBUTOR,
    carbonV2YieldRouterContract: process.env.CARBON_V2_YIELD_ROUTER,
    kycWhitelistContract: process.env.KYC_WHITELIST_CONTRACT,
    usdcTokenContract: process.env.USDC_TOKEN_CONTRACT,
    agroforestryProjectFactoryContract:
      process.env.AGROFORESTRY_PROJECT_FACTORY_CONTRACT,
    icon: HardhatIcon,
  },
};

export default networkConfig;
